export default __webpack_public_path__ + "static/media/logo.aab356ca.svg";